import React, { useState, useEffect } from 'react';
import { Grid, Chip, Button, Paper } from '@material-ui/core';
import axios from "axios";
import "./index.scss";
import { cnpjMask, dateParser } from "others/services";
import useApi from 'hooks/useApi';

function Servicos(){
    const api = useApi();
    document.title = 'BSI - Lista de Servicos';

    const [servicos, setServicos] = useState([]);

    useEffect(() => {
        loadServicos();
    }, []);

    async function loadServicos(){

        try {
            const request = await api.get("/servicos");
            const response = request.data.payload;
            setServicos(response);
            
        } catch (error) {
            
        }
    }

    async function removeServico(id){

        try {
            await api.del(`/servicos/${id}`);

            const newServicos = servicos.filter(value => value.id !== id);
            setServicos(newServicos);

        } catch (error) {
            console.log(error);
        }

    }

    return ( 
        <>
            <Grid className="servicos listar" container spacing={2}>
                <div className="page-box">
                    <div className="title">
                        Lista de Servicos
                    </div>
                    <Paper elevation={3} className="content">
                    <table>
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Titulo</th>
                                <th>Quantidade</th> 
                                <th>Ações</th> 
                            </tr>
                        </thead>
                        <tbody>
                            {
                                servicos.map(value => (
                                    <tr key={value.id}>
                                        <td>{value.id}</td>
                                        <td>{value.titulo}</td>
                                        <td>{value.qtd}</td>
                                        <td>
                                            <a className="btn blue-bg small" href={`servicos/${value.id}`}>Editar</a>
                                            <a className="btn gray-bg small" onClick={() => removeServico(value.id)}>Remover</a>
                                        </td>
                                    </tr>
                                ))
                            }
                           
                        </tbody>
                    </table>
                    <br/>
                    <br/>
                    <Grid className="page-actions borded" container justify="flex-start" alignItems="center">
                        <Button href='servicos/novo' variant="contained" color="primary">Adicionar</Button>
                    </Grid>
                    </Paper>
                </div>

            </Grid>

        </>
    )
    
}

export default Servicos;